import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
import { XIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show the floating CTA after scrolling 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-436">
      {isVisible && <motion.div className="fixed bottom-6 right-6 z-50" initial={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.3
    }} data-id="element-437">
          <div className="bg-white p-6 rounded-xl shadow-2xl border border-gray-100 max-w-sm" data-id="element-438">
            <div className="flex justify-between items-center mb-4" data-id="element-439">
              <h4 className="font-bold text-blue-900 text-lg" data-id="element-440">
                Prêt à commencer ?
              </h4>
              <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 bg-gray-100 p-1 rounded-full" data-id="element-441">
                <XIcon size={18} data-id="element-442" />
              </button>
            </div>
            <p className="text-gray-600 mb-4" data-id="element-443">
              Démarrez votre essai gratuit de 7 jours et accédez à toutes les
              opportunités d'affaires en Afrique.
            </p>
            <Link to="/essai-gratuit" className="w-full block" data-id="element-444">
              <Button variant="primary" fullWidth className="shadow-lg shadow-yellow-500/20 mb-3 flex items-center justify-center" data-id="element-445">
                <span data-id="element-446">Essai gratuit 7 jours</span>
                <ArrowRightIcon size={16} className="ml-2" data-id="element-447" />
              </Button>
            </Link>
            <div className="text-center text-xs text-gray-500" data-id="element-448">
              Aucune carte de crédit requise
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}